var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 28,
    viewBox: "0 0 107 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20647 0.297103H12.1794V14.2889L3.2623 27.0881H0V0.297103H3.97298V19.1516L8.20647 13.075V0.297103Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2857 27.0669V0.297201H17.2587V27.0672L13.2857 27.0669Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8343 0.297201L25.2334 11.8018C28.123 13.7491 29.4261 14.6269 31.1158 15.766V27.1304H27.1428V17.8305L22.9093 14.9775V27.1304H18.9363V0.360467H22.9093V8.14439L28.0936 0.297201H32.8343Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4249 27.0669V0.297201H37.3979V27.0672L33.4249 27.0669Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.282 0.297201H51.255V27.0672H47.282V18.5341L43.0485 15.5866V27.0672H39.0756V0.297201H43.0485V10.7939L47.282 13.7415V0.297201Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9729 17.2519V13.3382H65.6844V16.9613L60.7655 27.1514C57.9002 27.1514 58.3171 27.2372 58.1725 26.9371C51.5929 13.3075 52.7598 15.7137 51.7907 13.7453C52.7589 11.7793 51.6229 14.1211 58.1929 0.511257C58.3381 0.210591 57.936 0.296917 60.7454 0.296917C66.0479 11.2832 65.348 9.38935 65.348 11.068H61.5455L59.5209 6.87374L56.204 13.745L59.5209 20.6163C60.8174 17.9328 60.9834 17.6022 61.1307 17.2513L58.9729 17.2519Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0862 8.13702L73.8311 13.7607L80.0862 19.3841V20.5146L69.4337 27.1627H68.0568V0.315551H69.4088L80.0862 7.00679V8.13702ZM77.1177 7.78817L70.3194 3.51379V23.994L77.1177 19.7335L70.4205 13.745L77.1177 7.78817Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7026 0.314356H92.3517L84.5501 12.5367H91.3055V14.7461H84.533L92.1837 26.9232H89.5462L82.0673 15.0192C81.7984 14.5911 81.8731 15.1251 81.8767 12.5746C82.7506 11.2046 88.6147 2.01932 89.7026 0.314356Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106.998 0.297234H102.33C102.321 0.297234 102.309 0.297234 102.294 0.297234H95.4166V2.53405H100.073V27.1246H102.344V2.53405H107C107 2.41993 106.998 0.728574 106.998 0.297234Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default ForwardRef;